import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js'; 
import { enumChariotAlarmInput} from '../../models/enumChariotAlarmInput';
import { enumChariotAlarmOperator } from '../../models/enumChariotAlarmOperator';
import moment from 'moment'
import { GraphTemplate } from '../../models/GraphTemplateModel'
import { flowConverter, pressureConverter, totalConverter } from '../../Utils/UnitConverters'
export interface Alarm {
    id: number;
    serial: number | undefined
    site: number | undefined
    channel: string;
    message: string;
    setLevel: number;
    clrLevel: number;
    setOperator: enumChariotAlarmOperator;
    input: string
}

export const loadLCAlarmLevels = (serial: number | null, setAlarms: (alarmsInput: Alarm[]) => void): void => {


    CallGetAPI(CreateUrl('/api/aquaguard/LCAlarmConfigurations?serial=' + serial), {})
        .then(data => {
            if (data.length > 0) {
                const alarmsTemp: Array<Alarm> = [];
                for (let i = 0; i < data.length; i++) {
                    let channel = "";
                    let setLevel = 0;
                    let clrLevel = 0;
                    let input = ""
                    if (data[i].setInput == enumChariotAlarmInput.FlowA && data[i].clrInput == enumChariotAlarmInput.FlowA) {
                        channel = "A";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'flow'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.Consumption && data[i].clrInput == enumChariotAlarmInput.Consumption) {
                        channel = "A";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'consumption'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.FlowB && data[i].clrInput == enumChariotAlarmInput.FlowB) {
                        channel = "B";
                        setLevel = data[i].setThreshold
                        clrLevel = data[i].clrThreshold
                        input = 'flow'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.ConsumptionB && data[i].clrInput == enumChariotAlarmInput.ConsumptionB) {
                        channel = "B";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'consumption'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.Pressure1Latest && data[i].clrInput == enumChariotAlarmInput.Pressure1Latest) {
                        channel = "C";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'pressure'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.Pressure2Latest && data[i].clrInput == enumChariotAlarmInput.Pressure2Latest) {
                        channel = "D";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'pressure'
                    }
                    if (channel != "") {
                        alarmsTemp.push({
                            id: data[i].id,
                            serial: serial,
                            site: undefined,
                            channel: channel,
                            message: data[i].alarmMessage,
                            setLevel: setLevel,
                            clrLevel: clrLevel,
                            setOperator: data[i].setOperator,
                            input
                        });
                    }


                }

                setAlarms(alarmsTemp)
            }


        })
        .catch(function (error) {
            console.log(error);

        });

}


export const loadLoggerAlarmLevels = (serial: number | null, startDate : Date, endDate: Date, setAlarms: (alarmData: Alarm[]) => void ): void => {

    // Only show alarm levels for single Chariot logger
    CallGetAPI(CreateUrl('/api/aquaguard/LoggerAlarmLevels?logger=' + serial + "&startDate=" + moment(startDate).format("yyyy-MM-DD") + "&endDate=" + moment(endDate).format("yyyy-MM-DD") + "T23:59:59"), {})
        .then(data => {
            if (data.length > 0) {

                const alarmsTemp: Alarm[] = [];
                const channels: Array<string> = data[0].channels.split(',');
                for (let i = 0; i < channels.length; i++) {
                    let channel = "";
                    let setLevel = 0;
                    let clrLevel = 0;
                    if (channels[i].startsWith("A:") && channels[i].length > 2) {
                        channel = "A";
                        setLevel = data[0].channelASetLevel
                        clrLevel = data[0].channelAClearLevel
                    }
                    if (channels[i].startsWith("B:") && channels[i].length > 2) {
                        channel = "B";
                        setLevel = data[0].channelBSetLevel
                        clrLevel = data[0].channelBClearLevel
                    }
                    if (channels[i].startsWith("C:") && channels[i].length > 2) {
                        channel = "C";
                        setLevel = data[0].channelCSetLevel;
                        clrLevel = data[0].channelCClearLevel;
                    }
                    if (channels[i].startsWith("D:") && channels[i].length > 2) {
                        channel = "D";
                        setLevel = data[0].channelDSetLevel;
                        clrLevel = data[0].channelDClearLevel;
                    }
                    if (channels[i].startsWith("E:") && channels[i].length > 2) {
                        channel = "E";
                        setLevel = data[0].channelESetLevel;
                        clrLevel = data[0].channelEClearLevel;
                    }
                    if (channel != "" && setLevel !== null && clrLevel !== null) {
                        alarmsTemp.push({
                            id: data[i].id,
                            serial: serial,
                            site: undefined,
                            channel: channel,
                            message: data[i].alarmMessage,
                            setLevel: setLevel,
                            clrLevel: clrLevel,
                            setOperator: data[i].setOperator,
                            input: ""
                        });
                    }


                }

                setAlarms(alarmsTemp)

            }

        })
        .catch(function (error) {
            console.log(error);

        });

} 


export const loadSiteAlarmLevels = (siteId: number, alarms: Alarm[], setAlarms: (alarmData: Alarm[]) => void): void => {

    // Only show alarm levels for single Chariot logger
    CallGetAPI(CreateUrl('/api/aquaguard/SiteAlarmConfigurations?siteId=' + siteId), {})
        .then(data => {

            if (data.length > 0) {
                const alarmsTemp = [];
                for (let i = 0; i < data.length; i++) {
                    let channel = "";
                    let setLevel = 0;
                    let clrLevel = 0;
                    let input = ""
                    if (data[i].setInput == enumChariotAlarmInput.FlowA && data[i].clrInput == enumChariotAlarmInput.FlowA) {
                        channel = "A";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'flow'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.Consumption && data[i].clrInput == enumChariotAlarmInput.Consumption) {
                        channel = "A";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'consumption'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.FlowB && data[i].clrInput == enumChariotAlarmInput.FlowB) {
                        channel = "B";
                        setLevel = data[i].setThreshold
                        clrLevel = data[i].clrThreshold
                        input = 'flow'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.ConsumptionB && data[i].clrInput == enumChariotAlarmInput.ConsumptionB) {
                        channel = "B";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'consumption'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.Pressure1Latest && data[i].clrInput == enumChariotAlarmInput.Pressure1Latest) {
                        channel = "C";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'pressure'
                    }
                    if (data[i].setInput == enumChariotAlarmInput.Pressure2Latest && data[i].clrInput == enumChariotAlarmInput.Pressure2Latest) {
                        channel = "D";
                        setLevel = data[i].setThreshold;
                        clrLevel = data[i].clrThreshold;
                        input = 'pressure'
                    }
                    if (channel != "") {
                        alarmsTemp.push({
                            id: data[i].id,
                            serial: undefined,
                            site: siteId,
                            channel: channel,
                            message: data[i].alarmMessage,
                            setLevel: setLevel,
                            clrLevel: clrLevel,
                            setOperator: data[i].setOperator,
                            input
                        });
                    }
                }
                setAlarms(alarmsTemp)
            }

        })
        .catch(function (error) {
            console.log(error);

        });

}


export const checkAlarmAxisLevels = (unitsAndValues: GraphTemplate[], alarms: Alarm[], setUnitsAndValues: (unitsAndValuesArg : GraphTemplate[]) => void): void => {

    const alarmDetails = {
        visible: false,
        minValue: Number.MAX_VALUE,
        maxValue: Number.NEGATIVE_INFINITY,
        channel: "",
        color: '',
        transparency: "15",
        labelSize: 14,
        message: "",
        operator: ""
    };

    if (unitsAndValues.length > 0 && alarms.length > 0) {
        const loggerUnitsAndValues = [...unitsAndValues];
        loggerUnitsAndValues.forEach(values => values.alarms = [])
        const filteredLoggerSettings = loggerUnitsAndValues.filter(item =>
            alarms.some(alarm => alarm.serial === item.serial)
        );

        filteredLoggerSettings.forEach((loggerSetting) => {
            alarms.forEach((alarm: Alarm) => {
                if (alarm.serial === loggerSetting.serial) {
                    const alarmDetailsCopy = { ...alarmDetails };  // fresh copy for each loop
                    const a = alarmDetailsCopy;
                    const l = loggerSetting.graphSettings;
                    const letters = ['A', 'B', 'C', 'D', 'E']
                    for (const letter of letters) {
                        let input = ""
                        switch (letter) {
                            case 'A':
                                input = 'flowA'
                                break;
                            case 'B':
                                input = 'flowB'
                                break;
                            case 'C':
                                input = 'pressureC'
                                break;
                            case 'D':
                                input = 'pressureD'
                                break;
                            case 'E':
                                input = 'pressureE'
                                break;

                        }
                        if (alarm.input === 'consumption') {
                            input = letter === 'A' ? 'flowAConsumption' : 'flowBConsumption'
                        }

                        if (alarm.channel === letter) {
                            a.channel = letter
                            a.message = alarm.message
                            let conversion = 1
                            if ((letter === 'A' || letter === 'B') && alarm.input === 'flow') {
                                conversion = flowConverter(l[`${input}Unit`], 'l/s')
                                if (letter === 'A') {
                                    a.color = unitsAndValues[0].graphSettings.flowAColor
                                } else {
                                    a.color = unitsAndValues[0].graphSettings.flowBColor
                                }
                            } else if ((letter === 'A' || letter === 'B') && alarm.input === 'consumption') {
                                conversion = totalConverter(l[`${input}Unit`], l[`${input}OriginalUnit`])
                                if (letter === 'A') {
                                    a.color = unitsAndValues[0].graphSettings.flowAConsumptionColor
                                } else {
                                    a.color = unitsAndValues[0].graphSettings.flowBConsumptionColor
                                }
                            } else {

                                conversion = pressureConverter(l[`${input}Unit`], l[`${input}OriginalUnit`])

                                if (conversion === null) {
                                    conversion = 1
                                }
                            }
                            if (!l[`${input}ZeroFlow`]) {
                                if (alarm.setOperator === enumChariotAlarmOperator.GreaterThan ||
                                    alarm.setOperator === enumChariotAlarmOperator.GreaterThanOrEqual) {
                                    a.operator = ">"
                                    if (alarm.setLevel * conversion >= 0) {
                                        if (alarm.setLevel * conversion > a.maxValue) {
                                            a.maxValue = parseFloat((alarm.setLevel * conversion).toFixed(2));

                                            if (l[`${input}MaxState`] === 'default') {
                                                l[`${input}MaxValue`] = Math.max(a.maxValue, l[`${input}MaxValue`], l[`${input}MinValue`]);
                                            }


                                        }
                                    } else {
                                        if (alarm.setLevel * conversion > a.minValue) {

                                            a.minValue = alarm.setLevel * conversion;
                                            if (l[`${input}MaxState`] === 'default') {
                                                l[`${input}MaxValue`] = Math.max(a.minValue, l[`${input}MinValue`], l[`${input}MaxValue`]);
                                            }
                                        }
                                    }

                                    if (alarm.clrLevel * conversion < a.minValue) {
                                        a.minValue = parseFloat((alarm.clrLevel * conversion).toFixed(2));
                                        if (l[`${input}MinState`] === 'default') {
                                            l[`${input}MinValue`] = Math.min(a.minValue, l[`${input}MinValue`], l[`${input}MaxValue`]);
                                        }
                                    }

                                    if (loggerSetting.graphSettings[`${input}OriginalMax`] > alarm.clrLevel * conversion) {
                                        a.visible = true
                                        if (loggerSetting.graphSettings[`${input}MaxValue`] < alarm.setLevel) {
                                            loggerSetting.graphSettings[`${input}MaxValue`] = alarm.setLevel
                                        }
                                    }
                                } else if (alarm.setOperator === enumChariotAlarmOperator.LessThan ||
                                    alarm.setOperator === enumChariotAlarmOperator.LessThanOrEqual) {
                                    a.operator = "<"

                                    if (alarm.setLevel * conversion >= 0) {
                                        console.log(alarm.setLevel * conversion, a.minValue)
                                        if (alarm.setLevel * conversion > a.minValue) {
                                            a.minValue = alarm.setLevel * conversion;
                                            console.log(a.minValue)
                                            if (l[`${input}MinState`] === 'default') {
                                                l[`${input}MinValue`] = Math.min(a.minValue, l[`${input}MinValue`], l[`${input}MaxValue`]);
                                            }
                                            console.log(l[`${input}MinValue`])
                                        }
                                    } else {
                                        if (alarm.setLevel * conversion < a.minValue) {
                                            a.minValue = alarm.setLevel * conversion;
                                            if (l[`${input}MinState`] === 'default') {
                                                l[`${input}MinValue`] = Math.min(a.minValue, l[`${input}MinValue`], l[`${input}MaxValue`]);
                                            }

                                        }
                                    }

                                    if (alarm.clrLevel * conversion > a.maxValue) {
                                        a.maxValue = alarm.clrLevel * conversion;
                                        console.log('clear level')
                                        if (l[`${input}MaxState`] === 'default') {
                                            l[`${input}MaxValue`] = Math.max(a.maxValue, l[`${input}MaxValue`], l[`${input}MinValue`]);
                                        }
                                    }
                                    if (loggerSetting.graphSettings[`${input}OriginalMin`] > alarm.clrLevel * conversion && loggerSetting.graphSettings[`${input}OriginalMax`] !== Number.MAX_VALUE) {
                                        a.visible = true
                                        if (l[`${input}MinValue`] < alarm.setLevel) {
                                            loggerSetting.graphSettings[`${input}MinValue`] = alarm.setLevel
                                        }
                                    }
                                }
                            }
                        }
                    }
                    loggerSetting.alarms.push(alarmDetailsCopy);  // add only if not a duplicate
                }
            });
        });

        loggerUnitsAndValues.forEach(units => {
            filteredLoggerSettings.forEach(setting => {
                if (units.serial === setting.serial) {
                    units = setting
                }
            })
        })
        setUnitsAndValues(loggerUnitsAndValues)
    }
};